module.exports = __webpack_public_path__ + "e2e0813d.png";